import {
    LENDER_AGREEMENT,
    LENDER_AGREEMENT_SUCCESS,
    LENDER_AGREEMENT_ERROR,
    UPDATE_AGREEMENT,
    UPDATE_AGREEMENT_SUCCESS,
    UPDATE_AGREEMENT_ERROR
} from '../actionType'

const initialState = {
    isLoading: true,
    lenderResponse: null,
    error: null,
    updateResponse:null,
    updateError:null
}

const LenderAgreementReducer = (state = initialState, action: any) => {
    const { type, payload } = action;
    switch (type) {

        case LENDER_AGREEMENT:
            return {
                ...state,
            }
        case LENDER_AGREEMENT_SUCCESS:
            return {
                ...state,
                isLoading: false,
                lenderResponse: payload
            }
        case LENDER_AGREEMENT_ERROR:
            return {
                ...state,
                isLoading: false,
                error: payload
            }
        case UPDATE_AGREEMENT:
            return {
                ...state,
            }
        case UPDATE_AGREEMENT_SUCCESS:
            return {
                ...state,
                updateResponse:payload
            }
        case UPDATE_AGREEMENT_ERROR:
            return {
                ...state,
                updateError:payload
            }
        default:
            return state
    }
}

export default LenderAgreementReducer;